<ds-metadata-field-wrapper [label]="label | translate">
    <ng-container *ngFor="let mdValue of mdValues; let last=last;">
      <ng-container *ngTemplateOutlet="(env.markdown.enabled && this.enableMarkdown ? markdown : simple); context: {value: mdValue.value}">
      </ng-container>
      <span class="separator" *ngIf="!last" [innerHTML]="separator"></span>
    </ng-container>
</ds-metadata-field-wrapper>

<ng-template #markdown let-value="value">
  <span class="dont-break-out" [innerHTML]="value | dsMarkdown | async">
  </span>
</ng-template>

<ng-template #simple let-value="value">
  <span class="dont-break-out preserve-line-breaks">{{value}}</span>
</ng-template>
